export default "__VITE_ASSET__DBV$nCor__"